import React, { Component } from 'react';

class ArrowButton extends Component {
  componentDidMount() {
    const { id } = this.props;
    const el = document.getElementById(`${id}`);
    el.addEventListener('click', this.handleClick);
  }

  componentWillUnmount() {
    const { id } = this.props;
    const el = document.getElementById(`${id}`);
    el.removeEventListener('click', this.handleClick);
  }

  handleClick = () => {
    const {
      activeStop,
      handleClick,
      currentStop: { name },
    } = this.props;
    const stopData = { stopName: name, stopNum: activeStop };
    handleClick(stopData);
  };

  render() {
    const { id, height, width, position, src } = this.props;
    return (
      <a-image
        id={id}
        class="clickable"
        height={height}
        width={width}
        position={position}
        src={src}
      />
    );
  }
}

export default ArrowButton;
